/** Format To / Cc / Bcc lines for message headers. */

function joinAddresses(list) {
  if (!Array.isArray(list) || !list.length) return "";
  return list.filter(Boolean).join(", ");
}

/** @returns {{ label: string, value: string }[]} */
export function getRecipientLines(msg, { outbound = false } = {}) {
  if (!msg) return [];
  const lines = [];
  if (outbound) {
    const to = joinAddresses(msg.toAddresses);
    if (to) lines.push({ label: "To", value: to });
  }
  const cc = joinAddresses(msg.ccAddresses);
  if (cc) lines.push({ label: "Cc", value: cc });
  const bcc = joinAddresses(msg.bccAddresses);
  if (bcc) lines.push({ label: "Bcc", value: bcc });
  return lines;
}

export function getOutboundHeaderTitle(msg) {
  const to = joinAddresses(msg?.toAddresses);
  return to ? `To: ${to}` : "To: (none)";
}

export function getOutboundHeaderSubtitle(msg) {
  return getRecipientLines(msg, { outbound: true })
    .filter((l) => l.label !== "To")
    .map((l) => `${l.label}: ${l.value}`)
    .join(" · ");
}
